import {FC, useState} from 'react'
import Errors from 'app/features/orders/drafts/draft/components/ShippingCompliance/Errors'
import EnableTaxCalculation from '../../edit/EnableTaxCalculation'

interface Props {
  errors: any[]
  isComplianceChecked: boolean
  onComplianceCheck: () => void
  customerId: string
  totalTax: number | any
  isCompliant: boolean
  isTaxFetching?: boolean
  disabled?: boolean
  orderDeliveryMethod: string
  isShowCrv?: boolean
}

const ShippingCompliance: FC<Props> = ({
  errors,
  isComplianceChecked,
  onComplianceCheck,
  isCompliant,
  customerId,
  isTaxFetching,
  orderDeliveryMethod,
  disabled,
  isShowCrv,
}) => {
  const [isFetching, setIsFetching] = useState(false)

  const handleShippingCompliance = async () => {
    try {
      setIsFetching(true)
      await onComplianceCheck()
    } catch (err) {
      console.error(err)
    } finally {
      setIsFetching(false)
    }
  }

  return (
    <>
      <div className='d-flex align-items-center gap-12 w-100'>
        <EnableTaxCalculation onComplianceCheck={onComplianceCheck} />
        {isFetching || isTaxFetching ? (
          <label className='d-flex flex-row text-gray-500 align-items-center'>
            <span className='indicator-progress d-block px-2'>
              <span className='spinner-border spinner-border-sm align-middle mt-1 text-info'></span>
            </span>
            <span className='pt-2'>Checking shipping compliance...</span>
          </label>
        ) : (
          <button
            id='btnAddTax'
            className='btn btn-link p-0 bg-transparent text-primary-active fw-bolder'
            data-bs-toggle='tooltip'
            data-bs-trigger='hover'
            title=''
            onClick={handleShippingCompliance}
            disabled={disabled}
          >
            {isCompliant
              ? isShowCrv
                ? 'Total Taxes (Sales Tax + CRV Tax)'
                : 'Sales Taxes'
              : 'Calculate Tax'}
          </button>
        )}
      </div>

      <Errors
        errors={errors}
        isCompliant={isCompliant}
        isComplianceChecked={isComplianceChecked}
        customerId={customerId}
        orderDeliveryMethod={orderDeliveryMethod}
      />
    </>
  )
}
export default ShippingCompliance
